<template>
  <div v-if="image" class="dialog-wrap">
    <b-dialog
      :mask="dialogData.mask"
      :mshow="dialogData.show"
      :maskOpacity="dialogData.maskOpacity"
      :maskBackground="dialogData.maskBackground"
      :maskClass="maskClass"
    >
    <!-- <div class="pop-mask"></div> -->
    <div class="pop-box">
      <div class="pop-image" @click="imageAction">
        <!-- <img :src="renderImage" /> -->
        <beast-image :image="image" :containerWidth="containerWidth"/>
      </div>
      <div class="close-box" @click="popClose">
        <div class="close"></div>
      </div>
    </div>
    </b-dialog>
  </div>
</template>

<script>
import BDialog from '@/components/dialog'
import beastImage from '@/components/image'

import { ensure_protocol } from '@beastshop/url-util'
import { transformLink, trackSkip } from '@/link'
import { lazyload } from '@/lazyload'
import track from '@/track'

const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

export default {
  name: ['pop-com'],
  props: {
    id: Number,
    name: String,
    image: {
      type: Object,
      default: {}
    },
    link: {
      type: Object,
      default: {}
    },
    dialog: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      containerWidth: (clientWidth/375)*275,
      maskClass: {
        'pop-anima': true
      },
      dialogData: {
        mask: (this.dialog.mask === undefined)?true:this.dialog.mask,
        show: (this.dialog.show === undefined)?true:this.dialog.show,
        maskOpacity: (this.dialog.maskOpacity === undefined)?'0.4':this.dialog.maskOpacity,
        maskBackground: (this.dialog.maskBackground === undefined)?'#000000':this.dialog.maskBackground
      },
    }
  },
  components: {
    BDialog,
    beastImage
  },
  computed: {
    renderImage () {
      return ensure_protocol(this.image.src || '')
    },
  },
  created () {
    this.init()
  },
  methods: {
    init () {

      sa.track('PopupAdExposure', {
        'PopupAd_id': this.id,
        'PopupAd_name': this.name
      })


      track({
        name: 'index-pop-expose',
        attrs: {
          id: this.id
        },
        wait: false
      })
    },
    imageAction () {
      sa.track('PopupAdClick', {
        'PopupAd_id': this.id,
        'PopupAd_name': this.name
      })

      trackSkip({
        trackData: {
          name: 'index-pop-click',
          attrs: {
            id: this.id
          },
          wait: false
        },
        link: transformLink({
          link: this.link
        })
      })
    },

    popClose () {
      track({
        name: 'index-pop-close',
        attrs: {
          id: this.id
        },
        wait: false
      })
      this.$emit('pop-close')
    }
  },
}
</script>

<style lang="stylus">
@import '../../common/styl/global.styl'
.pop-anima
  animation pop 400ms
.pop-box
  width rem(275)
  .pop-image
    width 100%
    // max-height rem(465)
    overflow hidden
    img
      width 100%
  .close-box
    width rem(32)
    height rem(32)
    border rem(1.5) solid #ffffff
    border-radius 50%
    background transparent
    margin rem(50) auto 0
    position relative
    .close
      position absolute
      width rem(18)
      height rem(1.5)
      background #ffffff
      left 50%
      top 50%
      transform translate(-50%, -50%) rotateZ(45deg)
      &:after
        content ""
        background #ffffff
        display block
        width rem(18)
        height rem(1.5)
        position absolute
        top 0
        left 0
        transform rotateZ(90deg)


@keyframes pop {
  from {
    opacity 0
  }
  to {
    opacity .7 
  }
}
</style>



// WEBPACK FOOTER //
// pop.vue?11d55244